import * as Constants from './constants'

const initialState = {
  contestLoading: false,
  draftLoading: false,
}

const reducer = function questionReducer (state = initialState, action) {
  switch (action.type) {
    case Constants.CONTEST_REQUEST:
      return {
        ...state,
        contestLoading: true,
        draftLoading: false,
        draft: undefined,
        messages: [{
          body: 'Fetching contests...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.CONTEST_SUCCESS:
      return {
        ...state,
        contests: action.result.data,
        contestLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.CONTEST_ERROR:
      return {
        ...state,
        contestLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.DRAFT_REQUEST:
      return {
        ...state,
        draftLoading: true,
        messages: [{
          body: 'Setting Draft...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DRAFT_SUCCESS:
      return {
        ...state,
        draft: action.result || [],
        draftLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DRAFT_ERROR:
      return {
        ...state,
        draftLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer
